import { Modal } from "@mui/material";
import Styles from "./ViewInjectionModal.module.css";
import { Close } from "@mui/icons-material";
import { formatDate, formatSlotTime } from "../../../../helpers/dateFormat";

const ViewInjectionModal = ({ open, handleClose, data }) => {
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">Requisition List</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.indentsMainContainer}>
            <div className={Styles.indentsMainTableSection}>
              <div className={Styles.tableIndentsContent}>
                <div className={Styles.tableIndentsHeaderSection}>
                  <div>Start & End Date</div>
                  <div>Start & End Time</div>
                  <div>Quantity (MW)</div>
                  <div>Energy Rate (₹/kWh)</div>
                </div>
                <div className={Styles.searchTableSection}>
                  {(Array.isArray(data) ? data : data?.slots || [])?.map(
                    (item, index) => {
                      return (
                        <div
                          key={item.id}
                          className={`${Styles.indentsListTable} ${
                            index % 2 === 0 ? Styles.evenRow : Styles.oddRow
                          }`}
                        >
                          <div className={Styles.indentsListHeading}>
                            {formatDate(item.dateStartAt)} {" - "}
                            {formatDate(item.dateEndAt)}
                          </div>
                          <div className={Styles.indentsListHeading}>
                            {formatSlotTime(item.slotStartAt) || "—"} -{" "}
                            {formatSlotTime(item.slotEndAt) || "—"}
                          </div>
                          <>
                            <div className={Styles.indentsListHeading}>
                              {item?.quantity ? (
                                item?.quantity
                              ) : (
                                <>
                                  {item.purchaseEnergy ||
                                    item.sellEnergy ||
                                    "—"}
                                </>
                              )}{" "}
                            </div>
                            <div className={Styles.indentsListHeading}>
                              {item?.amount ? (
                                <>
                                  {" "}
                                  {item?.energyRateType === "FIXED"
                                    ? item?.amount
                                    : item?.energyRateType === "DAM_PLUS"
                                      ? `DAM+${item?.amount}`
                                      : `DAM-${item?.amount}`}
                                </>
                              ) : (
                                <>
                                  {item?.energyRateStr ||
                                    item.landingCost ||
                                    item.sellingCost ||
                                    "—"}
                                </>
                              )}
                            </div>
                          </>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>

              <div className={Styles.commentRow}>
                <span className={Styles.headerLabel}>Comments</span>
                <span
                  style={{ color: "var(--fourth-color-text)" }}
                  className={Styles.headerValue}
                >
                  {data?.comment}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewInjectionModal;
